import React, { useState } from "react";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import { Box, FormControl, Typography } from "@mui/material";
import TextField from "@mui/material/TextField";

const StatusDropdown = ({ options, selectedValue, onChange }) => {
  const [searchQuery, setSearchQuery] = useState("");
  const [dropDownOpen, setDropdownOpen] = useState(false);
  const handleOpen = () => setDropdownOpen(true);
  const handleClose = () => {
    setDropdownOpen(false);
    setSearchQuery("");
  };

  const handleSearchClick = (event) => {
    event.stopPropagation();
    setDropdownOpen(true);
  };

  const handleSearchChange = (event) => {
    setSearchQuery(event.target.value);
    setDropdownOpen(true);
  };
  const handleKeyDown = (event) => {
    const keysToPrevent = [
      ...Array.from({ length: 26 }, (_, i) => String.fromCharCode(97 + i)),
      ...Array.from({ length: 9 }, (_, i) => String(i + 1)),
    ];
    // Add any other keys that are causing issues
    if (keysToPrevent.includes(event.key?.toLowerCase())) {
      event.stopPropagation(); // Prevents the Select from intercepting the key press
    }
  };

  const filteredOptions = options.filter((items) =>
    items?.toLowerCase().includes(searchQuery?.toLowerCase())
  );

  return (
    <FormControl
      fullWidth
      size="small"
      sx={{
        "& .MuiOutlinedInput-root": {
          height: "55px",
          width: "150px",
          borderRadius: "8px",
          marginTop: "5px",
          marginRight: "20px",
        },
      }}
      variant="outlined"
    >
      <Select
        id="Dropdown"
        // label="Status"
        value={selectedValue}
        onChange={onChange}
        displayEmpty
        open={dropDownOpen}
        onOpen={handleOpen}
        onClose={handleClose}
        MenuProps={{
          PaperProps: {
            style: {
              maxHeight: 300, // Control dropdown height
              overflowY: "auto",
            },
          },
          autoFocus: false, // Prevent autofocus on the first item in the dropdown
        }}
        sx={{
          "& .MuiSelect-select": {
            bgcolor: "transparent", // Remove background color
            borderColor: "transparent", // Remove border color
          },
          "& .MuiOutlinedInput-root": {
            "& fieldset": {
              borderColor: "transparent", // Remove border color
            },
            "&:hover fieldset": {
              borderColor: "transparent", // Remove border color on hover
            },
            "&.Mui-focused fieldset": {
              borderColor: "transparent", // Remove border color when focused
            },
          },
        }}
        renderValue={(selected) => {
          if (selected === "") {
            return (
              <Typography
                variant="body2"
                sx={{
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  maxWidth: "220px",
                }}
              >
                {"Select status"}
              </Typography>
            );
          }
          const selectedItem = options.find((item) => item === selected);
          return (
            <Typography
              variant="body2"
              fontWeight="bold"
              sx={{
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
                maxWidth: "220px",
              }}
            >
              {selectedItem ? selectedItem : ""}
            </Typography>
          );
        }}
      >
        {/* Static Search Bar */}
        <Box
          sx={{
            padding: "8px",
            position: "sticky",
            top: 0,
            backgroundColor: "white",
            zIndex: 1,
          }}
        >
          <TextField
            fullWidth
            size="small"
            placeholder="Search..."
            value={searchQuery}
            onChange={handleSearchChange}
            onClick={handleSearchClick} // Ensure dropdown stays open when clicking the search bar
            onKeyDown={handleKeyDown} // Handle key down events
            sx={{
              margin: "8px 0",
            }}
          />
        </Box>

        {/* Dynamically Filtered List */}
        {filteredOptions.length > 0 ? (
          filteredOptions.map((items, index) => (
            <MenuItem key={index} value={items}>
              <Typography
                variant="body2"
                fontWeight="bold"
                sx={{
                  display: "flex",
                  alignItems: "center",
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  maxWidth: "250px",
                }}
              >
                <div style={{ display: "flex", alignItems: "center" }}>
                  {items}
                </div>
              </Typography>
            </MenuItem>
          ))
        ) : (
          <MenuItem disabled>
            <Typography variant="body2" sx={{ color: "#9e9e9e" }}>
              No results found
            </Typography>
          </MenuItem>
        )}
      </Select>
    </FormControl>
  );
};

export default StatusDropdown;
